import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress';
import MaterialIcon from './../../components/MaterialIcon';
import Config from '../../constants/appConfig';
import Calls from '../../components/util/calls';
import tools from '../../components/util/tools';
import saveAs from 'file-saver';
import { notification } from 'antd';

import Units from '../../components/util/units';
class ApplicationReportModal extends React.Component {
  baseState = {
    open: false,
    loading: false,
    job: null,
    exeItem: null,
    reportItem: null,
    idJob: null,
    task: null,
    guidLink: '',
    id_report: '',
    title: '',
    title_sk: '',
    titulo: '',
    cliente: '',
    selectedProperty: '',
    customPropertyName: '',
    isCustomProperty: false,
    properties: [],
    poligonos: [],
    id_aircraftbrand: 0,
    id_aircraftmodel: 0,
    aircraftbrands: [],
    aircraftmodels: [],
    areaTotalAplicada: '',
    inicioAplicacao: '',
    fimAplicacao: '',
    ordemServico: '',
    observacoes: '',
    nomePiloto: '',
    aeronavePrefixT: '',
    alturaCultura: '',
    talhoes: [],
    weatherData: [],
    windSpeedUnit: Units.getSpeedUnit(this.props.res),
    arrFuel: [],
    percSize: 100,

    checkResumo: false,
    checkResumoDetalhado: false,
    checkResumoTitulo: true,
    checkResumoCliente: true,
    checkResumoPropriedade: true,
    checkResumoArea: true,
    checkResumoFaixa: true,
    checkResumoVazao: true,
    checkResumoInicio: true,
    checkResumoFim: true,
    checkResumoAeronave: true,
    checkResumoPiloto: true,
    checkResumoTalhoes: true,
    checkResumoLatLng: true,
    checkResumoAlturaCultura: true,

    checkTrajetoria: true,
    checkPoligono: true,
    checkPoligonoLimpo: false,
    checkMapa: true,
    checkCoordenadas: true,

    checkVazao: true,
    checkVolume: true,
    checkAltura: true,
    checkCliente: true,
    checkAeronave: true,
    checkClima: true,
    checkVelocidade: true,
    checkFaixa: true,
  };

  state = Object.assign({}, this.baseState);

  componentWillUnmount() {
    this.setState = () => {};
  }

  getFirstExecutionItem = (job) => {
    if (!job || !job.list_exe || !job.list_exe.length) return null;

    return job.list_exe.filter(function (item) {
      return item && item.guid && item.progress_task === 100;
    })[0] || job.list_exe.filter(function (item) {
      return item && item.guid;
    })[0] || job.list_exe[0];
  };


  getReportItem = (job) => {
    if (!job || !job.list_rel || !job.list_rel.length) return null;

    return job.list_rel.filter(function (item) {
      return item && item.guid && item.progress_task === 100;
    })[0] || job.list_rel.filter(function (item) {
      return item && item.guid;
    })[0] || job.list_rel[0];
  };

  open = (job) => {
    const exeItem = this.getFirstExecutionItem(job);
    const reportItem = this.getReportItem(job);

    if (!job || !reportItem || !reportItem.guid) {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    const savedUnit = localStorage.getItem('windSpeedUnit') ? localStorage.getItem('windSpeedUnit') : Units.getSpeedUnit(this.props.res);

    this.setState(Object.assign({}, this.baseState, {
      open: true,
      loading: true,
      job: job,
      exeItem: exeItem,
      reportItem: reportItem,
      guidLink: reportItem.guid,
      windSpeedUnit: savedUnit
    }), () => {
      this.loadDomain('AIRCRAFTMODEL', 'aircraftbrands');
      this.getProfileAuto();
      this.loadReportData(job, exeItem, reportItem);
    });
  };

  close = () => {
    if (this.state.loading) return;
    this.setState({ open: false });
  };

  loadReportData = (job, exeItem, reportItem) => {
    const apiUrl = Config.server + '/job_check/importzjob/' + reportItem.guid;
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        let taskId = null;
        if (result && result.data && result.data.task) taskId = result.data.task;
        if (!taskId && result && result.task && result.task.id) taskId = result.task.id;
        if (!taskId && reportItem.id_task) taskId = reportItem.id_task;
        if (!taskId && reportItem.task) taskId = reportItem.task;
        if (!taskId && exeItem && exeItem.id_task) taskId = exeItem.id_task;
        if (!taskId && exeItem && exeItem.task) taskId = exeItem.task;

        const idJob = result && result.id_job ? result.id_job : job.id;

        this.setState({ task: taskId, idJob: idJob }, () => {
          if (taskId) {
            this.loadGetResult(taskId, job, exeItem, idJob);
          } else if (result && result.data && result.data.importzjob) {
            this.applyResultData(result.data.importzjob, job, exeItem, idJob, taskId);
          } else {
            this.setState({ loading: false });
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        });
      })
      .catch((error) => this.handleError(error));
  };

  loadGetResult = (taskId, job, exeItem, idJob) => {
    const apiUrl = Config.server + '/getResult/' + taskId;
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((response) => {
        if (response.status !== 200) throw response;
        return Calls.toJSON(response.headers.get('content-length'), response.body, () => {});
      })
      .then((result) => {
        if (!result || result === 'file not found.') {
          throw new Error('file not found.');
        }

        const data = typeof result === 'string' ? JSON.parse(result) : result;
        this.applyResultData(data, job, exeItem, idJob, taskId);
      })
      .catch((error) => this.handleError(error));
  };

  applyResultData = (data, job, exeItem, idJob, taskId) => {
    const serviceOrder = data && data.service_order ? data.service_order : null;
    const polygons = data && data.polygons && Array.isArray(data.polygons) ? data.polygons : [];
    const idClient = data && data.id_client ? data.id_client : job && job.id_client ? job.id_client : null;

    let ordemServico = '';
    if (serviceOrder) {
      const serviceOrderTitle = serviceOrder.title ? serviceOrder.title : '';
      const serviceOrderNumber = serviceOrder.order_number ? serviceOrder.order_number : '';

      if (serviceOrderTitle && serviceOrderNumber) ordemServico = serviceOrderTitle + ' - ' + serviceOrderNumber;
      else if (serviceOrderTitle) ordemServico = serviceOrderTitle;
      else if (serviceOrderNumber) ordemServico = String(serviceOrderNumber);
    }

    const startDate = this.getStartDate(data, exeItem, polygons);
    const endDate = this.getEndDate(data, exeItem, polygons);

    const talhoes = polygons.map((polygon) => {
      const coordinates = polygon && polygon.poly && polygon.poly.geometry && polygon.poly.geometry.coordinates && polygon.poly.geometry.coordinates[0]
        ? polygon.poly.geometry.coordinates[0]
        : [];
      const firstCoordinate = coordinates && coordinates.length ? coordinates[0] : [];

      return {
        name: polygon && polygon.name ? polygon.name : '',
        latitude: firstCoordinate && firstCoordinate.length > 1 ? firstCoordinate[1] : '',
        longitude: firstCoordinate && firstCoordinate.length > 0 ? firstCoordinate[0] : ''
      };
    });

    const area = data && data.apl && data.apl.area_aplicada ? data.apl.area_aplicada :
      exeItem && exeItem.area_spray ? exeItem.area_spray :
        exeItem && exeItem.area_polygon ? exeItem.area_polygon : '';

    const title = data && data.title ? data.title : job && job.title ? job.title : '';
    const client = data && data.customerName ? data.customerName :
      data && data.customername ? data.customername :
        exeItem && exeItem.client_name ? exeItem.client_name :
          exeItem && exeItem.client ? exeItem.client : '';

    this.setState({
      idJob: idJob,
      id: idJob,
      task: taskId,
      title: title,
      title_sk: exeItem && exeItem.title ? exeItem.title : title,
      titulo: title,
      cliente: client,
      selectedProperty: this.getPropertyName(data, job),
      isCustomProperty: false,
      poligonos: polygons,
      areaTotalAplicada: area,
      inicioAplicacao: startDate,
      fimAplicacao: endDate,
      ordemServico: ordemServico,
      nomePiloto: data && data.pilotName ? data.pilotName : exeItem && exeItem.pilot ? exeItem.pilot : '',
      aeronavePrefixT: data && data.aeronavePrefix ? data.aeronavePrefix : exeItem && exeItem.plane ? exeItem.plane : '',
      talhoes: talhoes,
      weatherData: data && data.weatherData ? data.weatherData : [],
      arrFuel: data && data.fuel && data.fuel.arrFuel ? data.fuel.arrFuel : [],
      loading: false
    }, () => {
      if (idClient) this.listProperties(idClient);
      this.readReportOperational(idJob);
    });
  };

  getPropertyName = (data, job) => {
    if (data && data.property) return data.property;
    if (data && data.service_order && data.service_order.property) return data.service_order.property;
    if (job && job.list_os && job.list_os.length > 0 && job.list_os[0].serviceOrder && job.list_os[0].serviceOrder.property) {
      return job.list_os[0].serviceOrder.property;
    }
    return '';
  };

  getStartDate = (data, exeItem, polygons) => {
    if (exeItem && exeItem.startDate) return this.toInputDateTime(exeItem.startDate);
    if (data && data.startDate) return this.toInputDateTime(data.startDate);
    if (polygons && polygons.length && polygons[0].startDate) return this.toInputDateTime(polygons[0].startDate);
    return '';
  };

  getEndDate = (data, exeItem, polygons) => {
    if (exeItem && exeItem.endDate) return this.toInputDateTime(exeItem.endDate);
    if (data && data.endDate) return this.toInputDateTime(data.endDate);
    if (polygons && polygons.length && polygons[0].endDate) return this.toInputDateTime(polygons[0].endDate);
    return '';
  };

  toInputDateTime = (value) => {
    if (!value) return '';
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return '';
    return tools.dateTimeZoneFormat(date, 'YYYY-MM-DDTHH:mm', this.props.res.timezone);
  };

  toServerDateTime = (value) => {
    if (!value) return '';
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return '';
    return tools.dateTimeZoneFormat(date, 'YYYY-MM-DD HH:mm:ss', this.props.res.timezone);
  };

  readReportOperational = (idJob) => {
    if (!idJob) return;

    const apiUrl = Config.server + '/report_operational/' + idJob;
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        if (result && result.length > 0) {
          let polygonData = [];
          try {
            polygonData = result[0].polygonData ? JSON.parse(result[0].polygonData) : [];
          } catch (e) {
            polygonData = [];
          }

          this.setState({
            id_report: result[0].id,
            titulo: result[0].title,
            cliente: result[0].client,
            selectedProperty: result[0].property,
            customPropertyName: result[0].customPropertyName,
            isCustomProperty: !!result[0].customPropertyName,
            areaTotalAplicada: result[0].area,
            aeronavePrefixT: result[0].plane,
            nomePiloto: result[0].pilot,
            alturaCultura: result[0].heightCulture,
            talhoes: polygonData.length > 0 ? polygonData : this.state.talhoes
          });
        }
      })
      .catch((error) => this.handleError(error, true));
  };

  saveOperationalReport = () => {
    const idJob = this.state.idJob;
    if (!idJob) return;

    let apiUrl = Config.server + '/report_operational';
    let method = 'POST';

    if (this.state.id_report) {
      apiUrl += '/' + this.state.id_report;
      method = 'PUT';
    }

    const formData = new URLSearchParams();
    formData.append('id_job', idJob);
    formData.append('title', this.state.titulo);
    formData.append('client', this.state.cliente);
    formData.append('property', this.state.selectedProperty);
    formData.append('customPropertyName', this.state.customPropertyName);
    formData.append('area', this.state.areaTotalAplicada);
    formData.append('startDate', this.toServerDateTime(this.state.inicioAplicacao));
    formData.append('endDate', this.toServerDateTime(this.state.fimAplicacao));
    formData.append('plane', this.state.aeronavePrefixT);
    formData.append('pilot', this.state.nomePiloto);
    formData.append('heightCulture', this.state.alturaCultura);
    formData.append('polygonData', JSON.stringify(this.state.talhoes));

    const options = {
      method: method,
      body: formData,
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then(() => {})
      .catch((error) => this.handleError(error, true));
  };

  download = () => {
    this.setState({ loading: true });

    let aircraftbrand;
    if (this.state.id_aircraftbrand > 0) {
      aircraftbrand = this.state.aircraftbrands.filter((brand) => Number(brand.id) === Number(this.state.id_aircraftbrand));
    }

    let aircraftmodel;
    if (this.state.id_aircraftmodel > 0) {
      aircraftmodel = this.state.aircraftmodels.filter((model) => Number(model.id) === Number(this.state.id_aircraftmodel));
    }

    const data = {
      culture: this.props.res.LINGUA,
      id: this.state.idJob,
      guid_link: this.state.guidLink,
      perc: this.state.percSize,
      arrFuel: this.state.arrFuel,
      config: {
        checkVazao: this.state.checkVazao,
        checkVolume: this.state.checkVolume,
        checkAltura: this.state.checkAltura,
        checkCliente: this.state.checkCliente,
        checkAeronave: this.state.checkAeronave,
        checkClima: this.state.checkClima,
        checkPoligono: this.state.checkPoligono,
        checkPoligonoLimpo: this.state.checkPoligonoLimpo,
        checkVelocidade: this.state.checkVelocidade,
        checkFaixa: this.state.checkFaixa,
        checkMapa: this.state.checkMapa,
        checkTrajetoria: this.state.checkTrajetoria,
        checkCoordenadas: this.state.checkCoordenadas
      },
      form: {
        ordemServico: this.state.ordemServico,
        observacoes: this.state.observacoes,
        nomePiloto: this.state.nomePiloto,
        alturaCultura: this.state.alturaCultura,
        prefixoAeronave: this.state.aeronavePrefixT,
        modeloAeronave: (aircraftbrand && aircraftbrand.length > 0 && aircraftmodel && aircraftmodel.length > 0) ? aircraftbrand[0].name + ' - ' + aircraftmodel[0].name : '',
        climate: {
          first: {},
          last: {}
        }
      },
      weatherData: this.state.weatherData,
      windSpeedUnit: this.state.windSpeedUnit,
      checkResumo: this.state.checkResumo,
      checkResumoDetalhado: this.state.checkResumoDetalhado,
      checkResumoTitulo: this.state.checkResumoTitulo,
      checkResumoCliente: this.state.checkResumoCliente,
      checkResumoPropriedade: this.state.checkResumoPropriedade,
      checkResumoArea: this.state.checkResumoArea,
      checkResumoFaixa: this.state.checkResumoFaixa,
      checkResumoVazao: this.state.checkResumoVazao,
      checkResumoInicio: this.state.checkResumoInicio,
      checkResumoFim: this.state.checkResumoFim,
      checkResumoAeronave: this.state.checkResumoAeronave,
      checkResumoPiloto: this.state.checkResumoPiloto,
      checkResumoTalhoes: this.state.checkResumoTalhoes,
      checkResumoLatLng: this.state.checkResumoLatLng,
      checkResumoAlturaCultura: this.state.checkResumoAlturaCultura,
      property: this.state.selectedProperty,
      otherProperty: this.state.customPropertyName,
      titulo: this.state.titulo,
      cliente: this.state.cliente,
      areaTotalAplicada: this.state.areaTotalAplicada,
      inicioAplicacao: this.state.inicioAplicacao,
      fimAplicacao: this.state.fimAplicacao,
      talhoes: this.state.talhoes,
    };

    const options = {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(Config.server + '/relaplicacao', options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.blob();
      })
      .then((result) => {
        this.setState({ loading: false, open: false });
        if (result.type === 'application/pdf' && result.size > 0) {
          saveAs(result, this.getFileName() + '-APL.pdf');
          this.saveOperationalReport();
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      })
      .catch((error) => this.handleError(error));
  };

  getFileName = () => {
    const text = this.state.title_sk ? this.state.title_sk : this.state.title;
    return String(text).replace(/[\\/:.!]/g, '-');
  };

  handleError = (error, silent) => {
    this.setState({ loading: false });
    if (error && (error.status === 401 || error.status === 403)) {
      this.props.link('/login');
      return;
    }
    if (!silent) {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    }
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  toggle = name => () => {
    this.setState({ [name]: !this.state[name] });
  };


  loadDomain = (domain, varState, id, cb) => {
    const apiUrl = id ? Config.server + '/domain/' + domain + '/' + id : Config.server + '/domain/' + domain;
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        this.setState({ [varState]: Array.isArray(result) ? result : [] }, () => {
          if (cb) cb(result);
        });
      })
      .catch((error) => this.handleError(error, true));
  };

  handleAircraftBrandChange = (event) => {
    const idAircraftBrand = event && event.target ? Number(event.target.value) : 0;
    this.setState({ id_aircraftbrand: idAircraftBrand, id_aircraftmodel: 0 }, () => {
      if (idAircraftBrand) {
        this.loadDomain('AIRCRAFTMODEL', 'aircraftmodels', idAircraftBrand);
      } else {
        this.setState({ aircraftmodels: [] });
      }
    });
  };

  listProperties = (idClient) => {
    if (!idClient) return;

    const apiUrl = Config.server + '/allProperty/' + idClient;
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        this.setState({ properties: Array.isArray(result) ? result : [] });
      })
      .catch((error) => this.handleError(error, true));
  };

  getProfileAuto = () => {
    const apiUrl = Config.server + '/profile_auto_application';
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        let resumo_config = null;
        try {
          if (result && result[0] && result[0].aplicacao && result[0].aplicacao[0] && result[0].aplicacao[0].resumo_config) {
            resumo_config = JSON.parse(result[0].aplicacao[0].resumo_config);
          }
        } catch (e) {
          resumo_config = null;
        }

        if (!resumo_config) return;

        this.setState({
          checkResumoTitulo: !!resumo_config.checkResumoTitulo,
          checkResumoCliente: !!resumo_config.checkResumoCliente,
          checkResumoPropriedade: !!resumo_config.checkResumoPropriedade,
          checkResumoArea: !!resumo_config.checkResumoArea,
          checkResumoFaixa: !!resumo_config.checkResumoFaixa,
          checkResumoVazao: !!resumo_config.checkResumoVazao,
          checkResumoInicio: !!resumo_config.checkResumoInicio,
          checkResumoFim: !!resumo_config.checkResumoFim,
          checkResumoAeronave: !!resumo_config.checkResumoAeronave,
          checkResumoPiloto: !!resumo_config.checkResumoPiloto,
          checkResumoTalhoes: !!resumo_config.checkResumoTalhoes,
          checkResumoLatLng: !!resumo_config.checkResumoLatLng,
          checkResumoAlturaCultura: !!resumo_config.checkResumoAlturaCultura,
          checkTrajetoria: !!resumo_config.checkTrajetoria,
          checkPoligono: !!resumo_config.checkPoligono,
          checkPoligonoLimpo: !!resumo_config.checkPoligonoLimpo,
          checkMapa: !!resumo_config.checkMapa,
          checkCoordenadas: !!resumo_config.checkCoordenadas,
          checkVazao: !!resumo_config.checkVazao,
          checkVolume: !!resumo_config.checkVolume,
          checkAltura: !!resumo_config.checkAltura,
          checkCliente: !!resumo_config.checkCliente,
          checkAeronave: !!resumo_config.checkAeronave,
          checkClima: !!resumo_config.checkClima,
          checkVelocidade: !!resumo_config.checkVelocidade,
          checkFaixa: !!resumo_config.checkFaixa,
        });
      })
      .catch((error) => this.handleError(error, true));
  };

  renderResumoFields = () => {
    if (!this.state.checkResumo) return null;

    return (
      <div style={{ marginLeft: 24, marginTop: 8, gridColumn: 'span 2' }}>
        <strong style={{ display: 'block', marginBottom: 8 }}>{this.props.res.CAMPOS_RESUMO}:</strong>
        <FormGroup>
          {this.renderSwitch('checkResumoTitulo', this.props.res.TITULO)}
          {this.renderSwitch('checkResumoCliente', this.props.res.CLIENTE)}
          {this.renderSwitch('checkResumoPropriedade', this.props.res.PROPRIEDADE)}
          {this.renderSwitch('checkResumoArea', this.props.res.AREA_TOTAL_APLICADA)}
          {this.renderSwitch('checkResumoFaixa', this.props.res.FAIXA_APP)}
          {this.renderSwitch('checkResumoVazao', this.props.res.VAZAO)}
          {this.renderSwitch('checkResumoInicio', this.props.res.INICIO)}
          {this.renderSwitch('checkResumoFim', this.props.res.FIM)}
          {this.renderSwitch('checkResumoAeronave', this.props.res.AERONAVE)}
          {this.renderSwitch('checkResumoPiloto', this.props.res.PILOTO)}
          {this.renderSwitch('checkResumoTalhoes', this.props.res.TALHOES_)}
          {this.renderSwitch('checkResumoLatLng', this.props.res.LATITUDE + ' / ' + this.props.res.LONGITUDE)}
          {this.renderSwitch('checkResumoAlturaCultura', this.props.res.ALTURA_CULTURA)}
        </FormGroup>
      </div>
    );
  };

  renderPropertyField = () => {
    const { res } = this.props;
    return (
      <div style={{ display: 'grid', gridTemplateColumns: this.state.isCustomProperty ? '1fr 1fr' : '1fr', gap: '1rem' }}>
        <FormControl fullWidth margin="dense">
          <InputLabel htmlFor="select-property">{res.PROPRIEDADE}</InputLabel>
          <Select
            id="select-property"
            value={this.state.isCustomProperty ? 'other-property' : this.state.selectedProperty}
            onChange={(event) => {
              const value = event.target.value;
              this.setState({
                selectedProperty: value === 'other-property' ? '' : value,
                isCustomProperty: value === 'other-property'
              });
            }}
          >
            <MenuItem key="0property" value="" disabled>{res.SELECIONE_PROPRIEDADE}</MenuItem>
            {this.state.properties.map((item, index) => (
              <MenuItem key={index} value={item.name}>{item.name}</MenuItem>
            ))}
            <MenuItem key="other-property" value="other-property">{res.OUTROTXT}</MenuItem>
          </Select>
        </FormControl>
        {this.state.isCustomProperty && this.renderTextField('customPropertyName', res.NOME_PROPRIEDADE)}
      </div>
    );
  };

  renderTextField = (name, label, props) => {
    return (
      <TextField
        label={label}
        fullWidth
        value={this.state[name]}
        onChange={this.handleChange(name)}
        margin="dense"
        {...props}
      />
    );
  };

  renderSwitch = (name, label) => {
    return <FormControlLabel control={<Switch color="primary" checked={this.state[name]} name={name} onClick={this.toggle(name)} />} label={label} />;
  };

  render() {
    const { res } = this.props;

    return (
      <Dialog open={this.state.open} onClose={this.close} maxWidth="sm" fullWidth PaperProps={{ style: { backgroundColor: 'white' } }}>
        <DialogTitle style={{ backgroundColor: 'white' }}>{res.CONFIGURACOES_RELATORIO}</DialogTitle>
        <DialogContent style={{ backgroundColor: 'white' }}>
          {this.state.loading ?
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <CircularProgress />
              <div style={{ marginTop: '1rem' }}>{res.PROCESSANDO}</div>
            </div>
            :
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                {this.renderTextField('ordemServico', res.ORDEM_SERVICO)}
                {this.renderTextField('observacoes', res.OBSERVACOES)}
                {this.renderTextField('nomePiloto', res.NOME_PILOTO)}
                {this.renderTextField('aeronavePrefixT', res.PREFIXO_AERONAVE)}

                <FormControl fullWidth margin="dense">
                  <InputLabel htmlFor="aircraftbrand">{res.FABRICANTE}</InputLabel>
                  <Select
                    id="aircraftbrand"
                    value={this.state.id_aircraftbrand || 0}
                    onChange={this.handleAircraftBrandChange}
                  >
                    <MenuItem key="0aircraftbrand" value={0}>{res.SELECIONE}</MenuItem>
                    {this.state.aircraftbrands.map((n, key) => <MenuItem key={key} value={Number(n.id)}>{n.name}</MenuItem>)}
                  </Select>
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <InputLabel htmlFor="aircraftmodel">{res.MODELO}</InputLabel>
                  <Select
                    id="aircraftmodel"
                    value={this.state.id_aircraftmodel || 0}
                    onChange={this.handleChange('id_aircraftmodel')}
                  >
                    <MenuItem key="0aircraftmodel" value={0}>{res.SELECIONE}</MenuItem>
                    {this.state.aircraftmodels.map((n, key) => <MenuItem key={key} value={Number(n.id)}>{n.name}</MenuItem>)}
                  </Select>
                </FormControl>

                {this.renderTextField('alturaCultura', res.ALTURA_CULTURA)}
              </div>

              <h3>{res.RELATORIO}</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div style={{ gridColumn: 'span 2' }}>
                  {this.renderSwitch('checkResumo', res.RELATORIO_RESUMIDO)}
                  {this.state.checkResumo && this.state.poligonos.length > 1 ? this.renderSwitch('checkResumoDetalhado', res.INFORMACAO_DETALHADA_POLIGONO) : null}
                  {this.renderResumoFields()}
                </div>

                {this.renderTextField('titulo', res.TITULO)}
                {this.renderTextField('cliente', res.CLIENTE)}
                {this.renderPropertyField()}
                {this.renderTextField('areaTotalAplicada', res.AREA_TOTAL_APLICADA)}
                {this.renderTextField('inicioAplicacao', res.INICIO_APLICACAO, { type: 'datetime-local', InputLabelProps: { shrink: true } })}
                {this.renderTextField('fimAplicacao', res.FIM_APLICACAO, { type: 'datetime-local', InputLabelProps: { shrink: true } })}
              </div>

              {this.state.talhoes.length > 0 &&
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
                  {this.state.talhoes.map((talhao, index) => (
                    <React.Fragment key={index}>
                      <TextField label={res.TALHAO + ' ' + (index + 1)} fullWidth value={talhao.name} onChange={(e) => {
                        const talhoes = this.state.talhoes.slice();
                        talhoes[index].name = e.target.value;
                        this.setState({ talhoes: talhoes });
                      }} />
                      <TextField label={res.LATITUDE} fullWidth value={talhao.latitude} onChange={(e) => {
                        const talhoes = this.state.talhoes.slice();
                        talhoes[index].latitude = e.target.value;
                        this.setState({ talhoes: talhoes });
                      }} />
                      <TextField label={res.LONGITUDE} fullWidth value={talhao.longitude} onChange={(e) => {
                        const talhoes = this.state.talhoes.slice();
                        talhoes[index].longitude = e.target.value;
                        this.setState({ talhoes: talhoes });
                      }} />
                    </React.Fragment>
                  ))}
                </div>
              }

              <h3>{res.MAPA}</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                {this.renderSwitch('checkTrajetoria', res.TRAJETORIA_VOO)}
                {this.renderSwitch('checkPoligono', res.POLIGONO_APLICADO)}
                {this.renderSwitch('checkPoligonoLimpo', res.POLIGONO_NAO_APLICADO)}
                {this.renderSwitch('checkMapa', res.MAPA_FUNDO)}
                {this.renderSwitch('checkCoordenadas', res.CAMADA_COORDENADAS)}
              </div>

              <h3>{res.TRABALHO}</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                {this.renderSwitch('checkVazao', res.VAZAO)}
                {this.renderSwitch('checkVolume', res.VOLUME_APLICADO)}
                {this.renderSwitch('checkAltura', res.ALTURA)}
                {this.renderSwitch('checkCliente', res.NOME_CLIENTE)}
                {this.renderSwitch('checkAeronave', res.PREFIXO_AERONAVE)}
                {this.renderSwitch('checkClima', res.VARIAVEIS_CLIMA)}
                {this.renderSwitch('checkVelocidade', res.VELOCIDADE)}
                {this.renderSwitch('checkFaixa', res.FAIXA_APLICACAO)}
              </div>
            </div>
          }
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'space-evenly', backgroundColor: 'white' }}>
          <Button disabled={this.state.loading} component="span" variant="contained" color="primary" className="popUpButton" title={res.PROCESSAR_JOB} onClick={this.download}>
            <MaterialIcon icon="file_download" />
          </Button>
          <Button disabled={this.state.loading} variant="contained" onClick={this.close} className="popUpButton">
            {res.CANCELAR}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ApplicationReportModal;
